<div class="dialog container-fluid col-md-12 mt-4">
    <div class="white">
        <form [formGroup]="submitCostingForm">
            <div class="row">
                <div class="col-md-4">
                    <p class="mb-0 regular">Part</p>
                    <div class="mb-0 medium text-truncate">{{modalData?.model_attributes?.file_name}}</div>
                </div>
                <div class="col-md-4">
                    <p class="mb-0 regular">Technology</p>
                    <select class="select arrow-img" [disabled]="true" (change)="onChangeDropdown($event.target.value)">
                        <option value=""></option>
                        <option *ngFor="let item of technologyList" [selected]="item.name === technology_name"
                            [value]="item.name">{{item.name}}</option>
                    </select>
                </div>
            </div>
            <div formArrayName="costing">
                <div class="mt-3" *ngFor="let item of getCostingList.controls; let i = index" [formGroupName]="i">
                    <div class="payment" formArrayName="costs">
                        <div class="head container-fluid mr-0 ml-0">
                            <div class="title mb-0">{{i+1}}. {{item?.value?.name}} </div>
                        </div>
                        <div *ngFor="let sub of getsubCostingList(item); let j = index" [formGroupName]="j">
                            <div *ngIf="item?.value?.name == 'Material Costs'" class="row mr-0 ml-0 pl-3"
                                style="border: 1px solid #DDDDDD;">
                                <div class="col-md-12 mt-4 mb-4">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <p class="mb-0 medium">Raw Material</p>
                                            <p class="mb-0 regular">[Type of Material]</p>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Quantity</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="raw_material_qty">
                                            <span class="ml-2 regular">MT</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Unit Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="raw_material_unitcost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="raw_material_totalcost" hidden>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'raw_material') | currency : currency}}
                                            </p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <p class="mb-0 medium">Additional Materials</p>
                                            <p class="mb-0 regular">[Details, if any]</p>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Quantity</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="add_material_qty">
                                            <span class="ml-2 regular">MT</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Unit Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="add_material_unitcost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="add_material_totalcost" hidden>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'additional_material') | currency : currency}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="item?.value?.name == 'Machining Costs'" class="row mr-0 ml-0 pl-3"
                                style="border: 1px solid #DDDDDD;">
                                <div class="col-md-12 mt-4 mb-4">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Machine Setup</p>
                                            <p class="mb-0 regular">Setup Costs</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="machine_setup_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'machine_setup') | currency : currency}}
                                            </p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <p class="mb-0 medium">Machining Time</p>
                                            <p class="mb-0 regular">[Hours, of Machining]</p>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Time</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="machining_time">
                                            <span class="ml-2 regular">Hours</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Hourly Rate</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="machining_time_hourly_rate">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'machining_time') | currency : currency}}
                                            </p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Tooling Costs</p>
                                            <p class="mb-0 regular">Tools and Wear</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="tooling_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'tooling_cost') | currency : currency}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="item?.value?.name == 'Labor Costs'" class="row mr-0 ml-0 pl-3"
                                style="border: 1px solid #DDDDDD;">
                                <div class="col-md-12 mt-4 mb-4">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <p class="mb-0 medium">Operator labor</p>
                                            <p class="mb-0 regular">Hours Worked</p>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Time</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="operator_labor_time">
                                            <span class="ml-2 regular">Hours</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Hourly Rate</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="operator_labor_hourly_rate">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'operator_labor') | currency : currency}}
                                            </p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <p class="mb-0 medium">Quality control</p>
                                            <p class="mb-0 regular">Inspection and Testing</p>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Time</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="quality_control_time">
                                            <span class="ml-2 regular">Hours</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Hourly Rate</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="quality_control_hourly_rate">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'quality_control') | currency : currency}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="item?.value?.name== 'Overhead Costs'" class="row mr-0 ml-0 pl-3"
                                style="border: 1px solid #DDDDDD;">
                                <div class="col-md-12 mt-4 mb-4">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Facility Overhead</p>
                                            <p class="mb-0 regular">Pro-rated Facility Costs</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="facility_overhead_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'facility_overhead') | currency : currency}}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Utilities</p>
                                            <p class="mb-0 regular">Electricity, Water, etc.</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="utilities_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0], 'utilities') |
                                                currency : currency}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="item?.value?.name == 'Packaging & Shipping Costs'" class="row mr-0 ml-0 pl-3"
                                style="border: 1px solid #DDDDDD;">
                                <div class="col-md-12 mt-4 mb-4">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Packaging Materials</p>
                                            <p class="mb-0 regular">Boxes, Wrapping, etc.</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="packaging_material_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'packaging_material') | currency : currency}}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Shipping</p>
                                            <p class="mb-0 regular">Transportaion Costs</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="shipping_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0], 'shipping') |
                                                currency : currency}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="item?.value?.name == 'Mold Costs'" class="row mr-0 ml-0 pl-3"
                                style="border: 1px solid #DDDDDD;">
                                <div class="col-md-12 mt-4 mb-4">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Pattern Creation</p>
                                            <p class="mb-0 regular">Cost of Creating Pattern</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="pattern_creation_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'pattern_creation') | currency : currency}}
                                            </p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Mold Making</p>
                                            <p class="mb-0 regular">Cost of Creating Molds</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="mold_making_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0], 'mold_making')
                                                | currency : currency}}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Mold maintenance</p>
                                            <p class="mb-0 regular">maintenance Costs</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="mold_maintenance_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'mold_maintenance') | currency : currency}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="item?.value?.name == 'Processing Costs'" class="row mr-0 ml-0 pl-3"
                                style="border: 1px solid #DDDDDD;">
                                <div class="col-md-12 mt-4 mb-4">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <p class="mb-0 medium">Melting</p>
                                            <p class="mb-0 regular">Melting Metal</p>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Time</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="melting_time">
                                            <span class="ml-2 regular">Hours</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Hourly Rate</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="melting_hourly_rate">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0], 'melting') |
                                                currency : currency}}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <p class="mb-0 medium">Pouring</p>
                                            <p class="mb-0 regular">Pouring Molten Metal</p>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Time</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="pouring_time">
                                            <span class="ml-2 regular">Hours</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Hourly Rate</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="pouring_hourly_rate">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0], 'pouring') |
                                                currency : currency}}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <p class="mb-0 medium">Cooling</p>
                                            <p class="mb-0 regular">Cooling and Solidification Time</p>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Time</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="cooling_time">
                                            <span class="ml-2 regular">Hours</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Hourly Rate</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="cooling_hourly_rate">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0], 'cooling') |
                                                currency : currency}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="item?.value?.name == 'Finishing Costs'" class="row mr-0 ml-0 pl-3"
                                style="border: 1px solid #DDDDDD;">
                                <div class="col-md-12 mt-4 mb-4">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <p class="mb-0 medium">Surface Treatment</p>
                                            <p class="mb-0 regular">Machining, Grinding, Polishing, etc.</p>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Time</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="surface_treatment_time">
                                            <span class="ml-2 regular">Hours</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Hourly Rate</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="surface_treatment_hourly_rate">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'surface_treatment') | currency : currency}}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <p class="mb-0 medium">Heat Treatment</p>
                                            <p class="mb-0 regular">Annealing, hardening, etc.</p>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Time</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="heat_treatment_time">
                                            <span class="ml-2 regular">Hours</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Hourly Rate</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="heat_treatment_hourly_rate">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'heat_treatment') | currency : currency}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="item?.value?.name == 'Tooling Costs'" class="row mr-0 ml-0 pl-3"
                                style="border: 1px solid #DDDDDD;">
                                <div class="col-md-12 mt-4 mb-4">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Die Design</p>
                                            <p class="mb-0 regular">Design and Engineering</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="die_design_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0], 'die_design')
                                                | currency : currency}}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Die Fabrication</p>
                                            <p class="mb-0 regular">Tooling and Die Making</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="die_fabrication_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'die_fabrication') | currency : currency}}
                                            </p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Die maintenance</p>
                                            <p class="mb-0 regular">maintenance and Repairs</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="die_maintenance_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'die_maintenance') | currency : currency}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="item?.value?.name == 'Miscellaneous Costs'" class="row mr-0 ml-0 pl-3"
                                style="border: 1px solid #DDDDDD;">
                                <div class="col-md-12 mt-4 mb-4">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-0 medium">Miscellaneous</p>
                                            <p class="mb-0 regular">[Details, if any]</p>
                                        </div>

                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Cost</p>
                                            <input class="col-md-4 custom-input" type="number" placeholder="Enter"
                                                formControlName="miscellaneous_cost">
                                            <span class="ml-2 regular">INR</span>
                                        </div>
                                        <div class="col-md-3">
                                            <p class="mb-0 regular">Total Cost</p>
                                            <p class="mb-0 large">{{calculateTotal(item?.value?.costs[0],
                                                'miscellaneous_cost') | currency : currency}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="mt-3">
            <div class="payment">
                <div class="head container-fluid mr-0 ml-0">
                    <div class="title mb-0">2. Machining Costs </div>
                </div>
                <div class="row mr-0 ml-0 pl-3" style="border: 1px solid #DDDDDD;">
                    <div class="col-md-12 mt-4 mb-4">
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Raw Material</p>
                                <p class="mb-0 regular">[Type of Material]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Additional Materials</p>
                                <p class="mb-0 regular">[Details, if any]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <div class="payment">
                <div class="head container-fluid mr-0 ml-0">
                    <div class="title mb-0">3. Labor Costs </div>
                </div>
                <div class="row mr-0 ml-0 pl-3" style="border: 1px solid #DDDDDD;">
                    <div class="col-md-12 mt-4 mb-4">
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Raw Material</p>
                                <p class="mb-0 regular">[Type of Material]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Additional Materials</p>
                                <p class="mb-0 regular">[Details, if any]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <div class="payment">
                <div class="head container-fluid mr-0 ml-0">
                    <div class="title mb-0">4. Overhead Costs </div>
                </div>
                <div class="row mr-0 ml-0 pl-3" style="border: 1px solid #DDDDDD;">
                    <div class="col-md-12 mt-4 mb-4">
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Raw Material</p>
                                <p class="mb-0 regular">[Type of Material]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Additional Materials</p>
                                <p class="mb-0 regular">[Details, if any]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <div class="payment">
                <div class="head container-fluid mr-0 ml-0">
                    <div class="title mb-0">5. Packaging and Shipping </div>
                </div>
                <div class="row mr-0 ml-0 pl-3" style="border: 1px solid #DDDDDD;">
                    <div class="col-md-12 mt-4 mb-4">
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Raw Material</p>
                                <p class="mb-0 regular">[Type of Material]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Additional Materials</p>
                                <p class="mb-0 regular">[Details, if any]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <div class="payment">
                <div class="head container-fluid mr-0 ml-0">
                    <div class="title mb-0">6. Miscellaneous Costs </div>
                </div>
                <div class="row mr-0 ml-0 pl-3" style="border: 1px solid #DDDDDD;">
                    <div class="col-md-12 mt-4 mb-4">
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Raw Material</p>
                                <p class="mb-0 regular">[Type of Material]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Additional Materials</p>
                                <p class="mb-0 regular">[Details, if any]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <div class="payment">
                <div class="head container-fluid mr-0 ml-0">
                    <div class="title mb-0">7. Mold Costs </div>
                </div>
                <div class="row mr-0 ml-0 pl-3" style="border: 1px solid #DDDDDD;">
                    <div class="col-md-12 mt-4 mb-4">
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Raw Material</p>
                                <p class="mb-0 regular">[Type of Material]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Additional Materials</p>
                                <p class="mb-0 regular">[Details, if any]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3">
            <div class="payment">
                <div class="head container-fluid mr-0 ml-0">
                    <div class="title mb-0">8. Processing Costs </div>
                </div>
                <div class="row mr-0 ml-0 pl-3" style="border: 1px solid #DDDDDD;">
                    <div class="col-md-12 mt-4 mb-4">
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Raw Material</p>
                                <p class="mb-0 regular">[Type of Material]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Additional Materials</p>
                                <p class="mb-0 regular">[Details, if any]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3">
            <div class="payment">
                <div class="head container-fluid mr-0 ml-0">
                    <div class="title mb-0">9. Finishing Costs </div>
                </div>
                <div class="row mr-0 ml-0 pl-3" style="border: 1px solid #DDDDDD;">
                    <div class="col-md-12 mt-4 mb-4">
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Raw Material</p>
                                <p class="mb-0 regular">[Type of Material]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Additional Materials</p>
                                <p class="mb-0 regular">[Details, if any]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3">
            <div class="payment">
                <div class="head container-fluid mr-0 ml-0">
                    <div class="title mb-0">10. Tooling Costs </div>
                </div>
                <div class="row mr-0 ml-0 pl-3" style="border: 1px solid #DDDDDD;">
                    <div class="col-md-12 mt-4 mb-4">
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Raw Material</p>
                                <p class="mb-0 regular">[Type of Material]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-3">
                                <p class="mb-0 medium">Additional Materials</p>
                                <p class="mb-0 regular">[Details, if any]</p>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Quantity</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">MT</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Unit Cost</p>
                                <input class="col-md-4 custom-input" type="text" placeholder="Enter">
                                <span class="ml-2 regular">INR</span>
                            </div>
                            <div class="col-md-3">
                                <p class="mb-0 regular">Total Cost</p>
                                <p class="mb-0 large">INR 0.00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

            <div class="mt-3" *ngIf="listofItem.length">
                <div class="sub-total container-fluid mr-0 ml-0">
                    <div class="mb-0 heading">Total Cost: </div>
                    <div class="mb-0 number">{{totalCost() | currency : currency}} </div>
                </div>
            </div>
            <div class="mt-3">
                <div class="notes container-fluid mr-0 ml-0">
                    <div class="mb-0 heading">Notes </div>
                    <!-- <div class="mt-1" *ngFor="let item of listofItem; let i = index">
                        <div class="mb-0 name">{{i+1}}. {{item.cost}}</div>
                        <p class="mb-0 regular" *ngIf="item.cost == 'Material Costs'">This includes the cost of raw
                            metals and any additional materials such
                            as
                            welding rods and fasteners.</p>
                        <p class="mb-0 regular" *ngIf="item.cost == 'Machining Costs'">This includes the cost of raw
                            metals and any additional materials such
                            as
                            welding rods and fasteners.</p>
                        <p class="mb-0 regular" *ngIf="item.cost == 'Labor Costs'">This includes the cost of raw metals and any additional materials such
                            as
                            welding rods and fasteners.</p>
                        <p class="mb-0 regular" *ngIf="item.cost == 'Overhead Costs'">This includes the cost of raw metals and any additional materials such
                            as
                            welding rods and fasteners.</p>
                        <p class="mb-0 regular" *ngIf="item.cost == 'Packaging & Shipping Costs'">This includes the cost of raw metals and any additional materials such
                            as
                            welding rods and fasteners.</p>
                        <p class="mb-0 regular" *ngIf="item.cost == 'Mold Costs'" >This includes the cost of raw metals and any additional materials such
                            as
                            welding rods and fasteners.</p>
                        <p class="mb-0 regular" *ngIf="item.cost == 'Processing Costs'">This includes the cost of raw metals and any additional materials such
                            as
                            welding rods and fasteners.</p>
                        <p class="mb-0 regular" *ngIf="item.cost == 'Finishing Costs'">This includes the cost of raw metals and any additional materials such
                            as
                            welding rods and fasteners.</p>
                        <p class="mb-0 regular" *ngIf="item.cost == 'Tooling Costs'">This includes the cost of raw metals and any additional materials such
                            as
                            welding rods and fasteners.</p>
                        <p class="mb-0 regular" *ngIf="item.cost == 'Miscellaneous Costs'">This includes the cost of raw metals and any additional materials such
                            as
                            welding rods and fasteners.</p>
                    </div> -->

                    <div class="mt-1">
                        <div class="mb-0 name">1. Material Costs </div>
                        <p class="mb-0 regular">This includes the cost of raw metals and any additional materials such
                            as
                            welding rods and fasteners.</p>
                    </div>
                    <div class="mt-1">
                        <div class="mb-0 name">2. Tooling and Equipment Costs </div>
                        <p class="mb-0 regular">Costs associating with the depreciation and maintenance of equipment, as
                            well as any special tools or fixtures required.</p>
                    </div>
                    <div class="mt-1">
                        <div class="mb-0 name">3. Processing Costs
                        </div>
                        <p class="mb-0 regular">Costs of machine setup, cutting, welding, machining and assembling
                            parts.</p>
                    </div>
                    <div class="mt-1">
                        <div class="mb-0 name">4. Labor Costs </div>
                        <p class="mb-0 regular">Operator and quality control labor cost.</p>
                    </div>
                    <div class="mt-1">
                        <div class="mb-0 name">5. Overhead Costs </div>
                        <p class="mb-0 regular">Facility-related costs and utilities.</p>
                    </div>
                    <div class="mt-1">
                        <div class="mb-0 name">6. Finishing Costs </div>
                        <p class="mb-0 regular">Costs for any surface treatments, such as painting, coating,
                            sandblasting, and heat treatments.</p>
                    </div>
                    <div class="mt-1">
                        <div class="mb-0 name">7. Packaging & Shipping </div>
                        <p class="mb-0 regular">Costs for packaging materials and shipping.</p>
                    </div>
                    <div class="mt-1">
                        <div class="mb-0 name">8. Miscellaneous Costs </div>
                        <p class="mb-0 regular">Any additional costs not covered in the above categories.</p>
                    </div>
                </div>
            </div>
            <!-- <pre>
            {{submitCostingForm.value | json}}
            </pre>  -->

            <div class="footer">
                <button class="btn-white mr-2 " (click)="close()">Cancel</button>
                <button class="orange ml-2" (click)="submitCost()">Submit</button>
            </div>
        </form>
    </div>
</div>